import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Rash treatment type.
 */
export const RashTreatment = new TreatmentType({
  id: '22',
  name: ConsultationTreatmentTypes.Rash,
});
